import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl, InputLabel } from '@mui/material';

import BaseSelectWithCheckboxes from '../../../../../../shared/components/base-select-with-checkboxes/base-select-with-checkboxes';
import { useSelectWithCheckboxesOnChange } from '../../../../../../shared/components/base-select-with-checkboxes/hooks/use-select-with-checkboxes-on-change/use-select-with-checkboxes-on-change.hook';
import { WithOptionsModel } from '../../../../../../shared/components/with-options/models/with-options.model';
import { FirmwareFilters } from '../../../../models/firmware-filters.model';
import { filterFirmwaresByEcus } from '../../../../store/slices/firmware.slice';
import { FirmwareFilterProps } from '../../types/firmware-filter-props.type';
import { withFirmwareFilterValues } from '../with-firmware-filters-values/with-firmware-filters-values';
import { withEcusOptions } from './components/with-ecus-options/with-ecus-options';

const EcusDropdown: FunctionComponent<
  FirmwareFilterProps & WithOptionsModel
> = (
  props: PropsWithChildren<FirmwareFilterProps & WithOptionsModel>
): ReactElement => {
  const {
    values: { ecuIds },
    options,
    setFieldValue,
    firmwareSelectFilters: { ecuIds: selectedEcuIds },
  } = props;

  const selectedEcusMapped = options
    .filter(item => selectedEcuIds.includes(item.id))
    .map(item => item.id);

  const onChange = useSelectWithCheckboxesOnChange<FirmwareFilters>(
    'ecuIds',
    setFieldValue,
    filterFirmwaresByEcus
  );

  return (
    <FormControl
      classes={{
        root: 'form-control-main',
      }}
      key="firmware-ecus"
      variant="filled"
      disabled={!options.length}
    >
      <InputLabel id="multiple-checkbox-label-ecus">ECU Model</InputLabel>

      <BaseSelectWithCheckboxes
        id="ecuIds"
        key="firmware-ecus"
        name="ecuIds"
        onChange={onChange}
        selectOptions={options}
        clearMultiSelectFilterAction={filterFirmwaresByEcus}
        value={selectedEcuIds ? selectedEcusMapped : ecuIds}
      />
    </FormControl>
  );
};

export default withFirmwareFilterValues(withEcusOptions(EcusDropdown));
